import { technicianLeaveList } from "constants/technicianLeave";
const initialState = {
  technicianLeaveList: {},
};

const technicianLeave = (state = initialState, action) => {
  switch (action.type) {
    case technicianLeaveList:
      return { ...state, technicianLeaveList: action.payload };
    default:
      return state;
  }
};

export default technicianLeave;
